import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { stateEnum, apiRoute } from "../constants/enum.js"
import customAPI from "../api/customAPI.js"
const { invoiceEntry } = stateEnum

const initialState = {
  detailParams: {},
  isNewEntry: false,
  rptInvData: [],
}

export const setInvoiceDetail = createAsyncThunk(
  "invoice/fetchInvoiceDetail",
  async ({ token, comp_code, trans_id, bill_type, trade_of, db_user }) => {
    try {
      
      const { data } = await customAPI.post(
        apiRoute.invoiceEntry.fetchInvoiceData,
        {
          compcode: comp_code,
          billtype: bill_type,
          tradeof: trade_of,
          transid: trans_id,
          db_user: db_user
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
    
      return data.data
    } catch (error) {
      console.log(error)
    }
  }
)





const invoiceEntrySlice = createSlice({
  name: invoiceEntry,
  initialState,
  extraReducers: (builder) => {
      builder
        .addCase(setInvoiceDetail.fulfilled, (state, action) => {
          state.rptInvData = action.payload
        })
        .addCase(setInvoiceDetail.rejected, (state, action) => {
          state.rptInvData = []
        })
    },
  reducers: {
    setNewEntryMode: (state, action) => {
      state.isNewEntry = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetailParams: (state) => {
      state.detailParams = {}
      state.isNewEntry = true

    },
    resetReportData: (state) => {
      state.rptInvData = []
    },
  },

})

export const { setDetailParams, resetDetailParams, setNewEntryMode,resetReportData } = invoiceEntrySlice.actions
export default invoiceEntrySlice.reducer
